export const PLACEHOLDER_ADS_TEXT = "Загрузка рекламы...";

export const AD_BLOCK_1_ID = "R-A-9656846-3";
export const AD_BLOCK_2_ID = "R-A-9656846-4";
export const AD_BLOCK_3_ID = "R-A-9656846-5";
export const AD_BLOCK_4_ID = "R-A-9656846-6";
export const AD_BLOCK_5_ID = "R-A-9656846-7";